export const fetchDomainOnlyData = async function (domain, groupName = "") {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/bookings/locations?domain=${domain}&groupname=${groupName}`,
      requestOptions
    );

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching site config", error);
  }
};
